import React, { useRef, useState, useEffect } from 'react';

const AudioPlayerBar = ({ audioUrl, title, durationSec }) => {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [playbackRate, setPlaybackRate] = useState(1);

    const togglePlay = () => {
        if (playing) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setPlaying(!playing);
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const handleProgressChange = (e) => {
        const time = (e.target.value / 100) * durationSec;
        audioRef.current.currentTime = time;
        setCurrentTime(time);
    };

    const togglePlaybackRate = () => {
        const rates = [1, 1.25, 1.5, 2];
        const nextIndex = (rates.indexOf(playbackRate) + 1) % rates.length;
        const nextRate = rates[nextIndex];
        setPlaybackRate(nextRate);
        audioRef.current.playbackRate = nextRate;
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const progress = (currentTime / durationSec) * 100;

    return (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 w-full max-w-xl px-4 z-50">
            <div className="bg-[#222425]/90 backdrop-blur-xl border border-white/10 shadow-2xl rounded-full h-16 flex items-center px-4 gap-4 text-white">
                <audio
                    ref={audioRef}
                    src={audioUrl}
                    onTimeUpdate={handleTimeUpdate}
                    onEnded={() => setPlaying(false)}
                />

                <button
                    onClick={togglePlay}
                    className="w-10 h-10 bg-[#00DA76] rounded-full flex items-center justify-center text-white text-lg transition-transform hover:scale-105 active:scale-95"
                >
                    {playing ? '⏸' : '▶'}
                </button>

                <div className="flex-1">
                    <div className="text-[11px] font-bold text-gray-400 uppercase tracking-tight truncate">
                        {playing ? 'Playing Analysis' : 'Listen Analysis'}: {title}
                    </div>
                    <div className="relative flex items-center h-4 mt-1">
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={progress || 0}
                            onChange={handleProgressChange}
                            className="absolute z-10 w-full h-1 opacity-0 cursor-pointer"
                        />
                        <div className="w-full bg-white/10 rounded-full h-1 overflow-hidden">
                            <div
                                className="bg-[#00DA76] h-full rounded-full transition-all duration-100"
                                style={{ width: `${progress}%` }}
                            />
                        </div>
                    </div>
                </div>

                <div className="text-[10px] font-bold text-gray-400 tabular-nums">
                    {formatTime(currentTime)} / {formatTime(durationSec)}
                </div>

                <button
                    onClick={togglePlaybackRate}
                    className="text-[10px] font-bold bg-white/10 px-2.5 py-1.5 rounded-lg text-gray-300 hover:bg-white/20 transition-colors"
                >
                    {playbackRate}x
                </button>
            </div>
        </div>
    );
};

export default AudioPlayerBar;
